/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 02/02/22
 */

import { FormControlProps, FormLabelProps, Select, SelectProps } from '@chakra-ui/react';
import React from 'react';
import {
    FormControlWrapperWithLabel,
    FormControlWrapperWithLabelProps,
} from '@/components/FormInputField/FormControlWrapper';

export interface LabeledSelectProps extends SelectProps, FormControlWrapperWithLabelProps {
    labelProps?: FormLabelProps;
    controlProps?: FormControlProps;
}

export const LabeledSelect = (props: LabeledSelectProps) => {
    const { label, labelSide, labelAlign, labelProps, controlProps, ...selectProps } = props;
    return (
        <FormControlWrapperWithLabel
            label={label}
            labelSide={labelSide}
            labelAlign={labelAlign}
            labelProps={labelProps}
            controlProps={controlProps}
        >
            <Select role="combobox" {...selectProps} />
        </FormControlWrapperWithLabel>
    );
};
